import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {
    ControlService, HeatingCurveService,
    IconService,
    SubtitlesService
} from "../../../core";
import {
    MenuElement,
    MenuElementType28,
    MenuElementType30,
    MenuType
} from "../../../models";
import {Options} from "@angular-slider/ngx-slider";
import {Subscription} from "rxjs";

@Component({
    selector: 'heating-curve',
    templateUrl: './heating-curve.component.html',
    styleUrls: ['./heating-curve.component.scss']
})
export class HeatingCurveComponent implements AfterViewInit, OnInit, OnDestroy {
    values: number[] = [];
    options: Options;

    elementVal: MenuElementType28 | MenuElementType30;
    elementValSubscription: Subscription;

    constructor(
        public control: ControlService,
        private icon: IconService,
        public subtitles: SubtitlesService,
        public heatingCurve: HeatingCurveService,
) {
    }

    ngOnInit() {
        const element = this.control.elementVal.getValue();
        this.setElementVal(element);
        this.setOptionsAndSliders();

        this.elementValSubscription = this.control.elementVal$.subscribe((newVal) => {
            if (!newVal) return;
            this.setElementVal(newVal);
            this.setOptionsAndSliders();
        });
    }

    ngOnDestroy() {
        if (this.elementValSubscription) {
            this.elementValSubscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    private setElementVal(element: MenuElement): void {
        const isType28 = element.type === 28;
        this.elementVal = isType28
            ? element as MenuElementType28
            : element as MenuElementType30;
    }

    private setOptionsAndSliders(): void {
        this.options = {
            floor: this.elementVal.params.min,
            ceil: this.elementVal.params.max,
            vertical: true,
        }
        this.heatingCurve.getHeatingCurve();
        this.setSlider();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setSlider(): void {
        this.values = this.heatingCurve.heatingCurveTable.map((val) => val.value);
    }
}
